import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor
} from '@angular/common/http';


import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private router: Router) 
    {}

        //correct running code with login route if error comes
        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

            let currentUser = localStorage.getItem('id_token');
            if (currentUser) {
                if(!request.headers.has("InterceptorSkipHeader")){
                    request = request.clone({
                        setHeaders: { 
                            Authorization: `Bearer ${currentUser}`
                        }
                    });
                }
          }//endif
         // return next.handle(request)
            return next.handle(request)
                .pipe(catchError((error) => {
                    if (error.status != 400) {
                        console.log('Error Occurred http interceptor');
                    }
                    return throwError(error);
                    //return Observable.throw(error);
                })) as any;

    }//end intercept

   

}//end class